import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import { Text } from "@/components/podkit/typography/Text";
import { Tooltip } from "@/components/Tooltip";
import type { FC } from "react";

export const RunnerName: FC<{ name: string } & PropsWithClassName> = ({ name, className }) => {
    return (
        <Tooltip content={name}>
            <Text className={cn("min-w-0 flex-shrink truncate text-base font-bold text-content-primary", className)}>
                {name}
            </Text>
        </Tooltip>
    );
};
